import { APIClient } from "../api";
import axios, { AxiosAdapter } from 'axios';
export default class BusinessUnitService extends APIClient {

    async GetById(businessUnitId: number) {
        const url = this.endpoint + `/BusinessUnit?$filter=(id eq ${businessUnitId} and Disabled eq 0)&$top=5000`;
        
        return this.api({
            method: 'get',
            url,
        });
    }

    async getAllBusinessUnit(businessArea: number) {
        const url = this.endpoint + `/BusinessUnit?$filter=(IdBusinessArea eq ${businessArea} and Disabled eq 0)&$top=5000`;
        
        if (typeof this.cancelToken != typeof undefined) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }

        //Save the cancel token for the current request
        this.cancelToken = axios.CancelToken.source();
        return this.api({
            method: 'get',
            url,
            cancelToken: this.cancelToken.token
        });
    }
}